import { JsPageItems } from "./_interface";
import ItoHeaderImage from "../../../assets/images/nml/alumni-recruitment/alumni-interivews/ito/header_img.webp";
import MiyasakaHeaderImage from "../../../assets/images/nml/alumni-recruitment/alumni-interivews/miyasaka/header_img.webp";
import ItoSectionOneImg from "../../../assets/images/nml/alumni-recruitment/alumni-interivews/ito/section_1.webp";
import ItoSectionTwoImg from "../../../assets/images/nml/alumni-recruitment/alumni-interivews/ito/section_2.webp";
import MiyasakaSectionOneImg from "../../../assets/images/nml/alumni-recruitment/alumni-interivews/miyasaka/section_1.webp";
import MiyasakaSectionTwoImg from "../../../assets/images/nml/alumni-recruitment/alumni-interivews/miyasaka/section_2.webp";
import MiyasakaSectionThreeImg from "../../../assets/images/nml/alumni-recruitment/alumni-interivews/miyasaka/section_3.webp";

export const NML_ALUMNI_INTERVIEWS: JsPageItems[] = [
  {
    id: 1,
    name: "ito-san-interview",
    key: "ito",
    headerImage: ItoHeaderImage,
    headerTitle: "page.nml.alumni_recruitment.ito_interview.header.title",
    headerDesignationDetails:
      "page.nml.alumni_recruitment.ito_interview.header.designation.details",
    intro: "page.nml.alumni_recruitment.ito_interview.intro",
    sections: [
      {
        heading:
          "page.nml.alumni_recruitment.ito_interview.sections.heading_1.title",
        content:
          "page.nml.alumni_recruitment.ito_interview.sections.heading_1.content",
        image: ItoSectionOneImg,
        imagePosition: "left",
      },
      {
        heading:
          "page.nml.alumni_recruitment.ito_interview.sections.heading_2.title",
        content:
          "page.nml.alumni_recruitment.ito_interview.sections.heading_2.content",
        image: "",
      },
      {
        heading:
          "page.nml.alumni_recruitment.ito_interview.sections.heading_3.title",
        content:
          "page.nml.alumni_recruitment.ito_interview.sections.heading_3.content",
        image: ItoSectionTwoImg,
        imagePosition: "right",
      },
    ],
  },
  {
    id: 2,
    name: "miyasaka-san-interview",
    key: "miyasaka",
    headerImage: MiyasakaHeaderImage,
    headerTitle: "page.nml.alumni_recruitment.miyasaka_interview.header.title",
    headerDesignationDetails:
      "page.nml.alumni_recruitment.miyasaka_interview.header.designation.details",
    intro: "page.nml.alumni_recruitment.miyasaka_interview.intro",
    sections: [
      {
        heading:
          "page.nml.alumni_recruitment.miyasaka_interview.sections.heading_1.title",
        content:
          "page.nml.alumni_recruitment.miyasaka_interview.sections.heading_1.content",
        image: MiyasakaSectionOneImg,
        imagePosition: "left",
      },
      {
        heading:
          "page.nml.alumni_recruitment.miyasaka_interview.sections.heading_2.title",
        content:
          "page.nml.alumni_recruitment.miyasaka_interview.sections.heading_2.content",
        image: MiyasakaSectionTwoImg,
        imagePosition: "left",
      },
      {
        heading:
          "page.nml.alumni_recruitment.miyasaka_interview.sections.heading_3.title",
        content:
          "page.nml.alumni_recruitment.miyasaka_interview.sections.heading_3.content",
        image: MiyasakaSectionThreeImg,
        imagePosition: "right",
      },
    ],
  },
];
